module.exports = __webpack_public_path__ + "028d9d7df17207617460904dcac55ade.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2127_teaser_image.jpg
// module id = 608
// module chunks = 0